/** 
 * @file   Apparel Filters
 * @author Neil Brownell
 * 
 * This script uses data attributes on apparel items
 * to allow for front-end DOM-based filtering.
 * 
 * The data attributes are set in /allit/views/product-page/product-list-item.php
 * The form controls are drawn in /allit/onnit/templates/store/apparel-filters.php
 * Styles are defined in /allit/onnit/styles/src/page/store/apparel-filters.less
 */

(function($){

    /**
     * Finds the intersection (overlap) between whichever arrays you pass in
     * So you could pass in an array of PIDs that match on the `color` parameter
     * and an array of PIDs that match on the `category` parameter
     * and the result would be a new array of ONLY those PIDs that are found in BOTH arrays
     * Borrowed from {@link https://stackoverflow.com/a/11076082}
     *
     * @param  {Array} [array1, array2...]
     * @return {Array} An array with the overlapped items from array1 and array2
     */
    function intersection(arrays) {
        return arrays.shift().filter(function(v) {
            return arrays.every(function(a) {
                return a.indexOf(v) !== -1;
            });
        });
    }


    /**
     * $.parseParams - parse query string parameters into an object
     * Borrowed from  {@link https://gist.github.com/kares/956897}
     * 
     * @param  {String} query A query string i.e. `size=medium&color=blue`
     * @return {Object} The parsed query i.e. `{size: "medium", color: "blue"}`
     */
    $.parseParams = function(query) {
        var params = {}, e;
        var re = /([^&=]+)=?([^&]*)/g;
        var decodeRE = /\+/g;  // Regex for replacing addition symbol with a space
        var decode = function (str) {return decodeURIComponent( str.replace(decodeRE, " ") );};

        while ( e = re.exec(query) ) { 
            var k = decode( e[1] ), v = decode( e[2] );
            if (k.substring(k.length - 2) === '[]') {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            }
            else params[k] = v;
        }
        return params;
    };


    /**
     * A jQuery collection to hold all the products represented in the DOM
     * @type {Object}
     */
    var $storeItems = $('.store-item');


    /**
     * An array of all the possible dimensions across which a user can filter
     * @type {Array}
     */
    var filterDimensions = ['gender', 'category', 'size', 'color', 'price'];


    /**
     * When we first load the page,
     * apply any filters that can be gleaned from the URL
     */
    applyInitialFilters();


    /**
     * Assign event handlers for UI elements
     */
    $(document).on('click', '.filter-label', toggleFilter);
    $(document).on('click', untoggleFilter);
    $(document).on('change', '.filter-option-checkbox', checkboxChange);
    $(document).on('click', '.btn-clear-filters', clearFilters);
    $(document).on('click', '.btn-clear-filters--mobile', clearFiltersMobile);
    $(document).on('click', '.btn-clear-filter', clearFilter);
    $(window).on('popstate', goBackwardInFilterHistory);


    /**
     * Toggles a filter menu open or closed
     * 
     * @param  {Object} event The click event which will be passed implicitly
     *     from the event handler
     */
    function toggleFilter (event) {
        var $filter = $(event.currentTarget).closest('.filter');
        var open = $filter.hasClass('is-open');
        $filter.toggleClass('is-open', !open);
        
        // If we are opening this menu, make sure other menus are closed
        // except on mobile (see the matchMedia query)
        if (!open && window.matchMedia("(min-width: 740px)").matches) {
            $('.filter').not($filter).removeClass('is-open');
        }
    }


    /**
     * Listens on the `document` for clicks outside the menu
     * in which case we’ll want to close the menu
     * 
     * @param  {Object} event The click event which will be passed implicitly
     *     from the event handler
     */
    function untoggleFilter (event) {
        if ($(event.target).closest('.filter').length == 0) {
            $('.filter').removeClass('is-open');
        }
    }



    /**
     * Unchecks all the checkboxes for every filter dimension
     */
    function clearCheckboxes() {
        $('.filter-option-checkbox').prop('checked', false);
    }



    /**
     * Calls clearCheckboxes() to uncheck all filter checkboxes
     * Then calls traverseParams() and updateCountHints()
     * to update the UI accordingly
     */
    function clearFilters() {
        clearCheckboxes();
        traverseParams({}, 'forward');
        updateCountHints({});
    }



    /**
     * Calls the clearFilters() function
     * and additionally closes the Filter flyout menu on mobile
     */
    function clearFiltersMobile() {
        clearFilters();
        $.magnificPopup.close();
    }



    /**
     * Clears any currently applied filters in a given dimension
     * This corresponds to a button on the bottom of each filter menu
     * 
     * @param  {Object} event The event passed by the click handler,
     *     which will determine the filter parameter we need to clear
     */
    function clearFilter(event) {
        // What button was clicked?
        var $el = $(event.currentTarget);

        // What is the parent filter dimension of that button?
        // i.e. Color, Gender, Size...
        var filterDimension = $el.attr('data-filter-key');

        // Uncheck all the checkboxes in that filter dimension
        $('.filter[data-filter-key="' + filterDimension + '"]')
            .removeClass('is-open')
            .find('.filter-option-checkbox')
            .prop('checked', false);

        // Reevaluate the filter parameters now that we’ve made changes
        var params = gatherParams();
        params = cleanParams(params);
        traverseParams(params, 'forward');
    }



    /**
     * Updates the count hints displayed by each filter option, for instance:
     * 
     * SIZE
     * --------
     * Small (14)
     * Medium (16)
     * Large (17)
     * XLarge (12)
     * 2XLarge (3)
     * 
     * @param  {Object} filteredSets This is the info we’ll need to deduce 
     *     the count hints. It’s the set of all Product IDs for each filter dimension
     *     of the currently active filters.
     */
    function updateCountHints(filteredSets) {

        // Look at each individual checkbox
        $('.filter-option-checkbox').each(function(index, el){

            var $checkbox = $(el),                                   // The checkbox itself
                $option = $checkbox.closest('.filter-option'),       // The parent element
                $count = $option.find('.filter-option-count:eq(0)'), // The hint text
                filterDimension = $checkbox.attr('data-filter-key'), // Color? Size? Price?
                filterDimensionValue = $checkbox.val(),              // Blue? XLarge? Less than $25?
                matches = [];                                        // Are any of these conditions met?

            // Iterate over each product
            $storeItems.each(function(index, product){

                // Send if off to another function for testing
                if (testProduct(filterDimension, filterDimensionValue, product) > 0) {

                    // If it matches, add its Product ID to the list
                    matches.push(parseInt($(product).attr('data-product-id')));
                }
            });

            // Take this list of PIDs that are a potential match for this checkbox
            var arrays = [matches];

            // Do we have any other arrays of PIDs we’ll need to intersect our matches with?
            // Like say this current checkbox is asking for everything that’s Blue
            // That’s great, but what if the user has also restricted us to looking for items Less than $25?
            // We’re going to need to cross-reference those results by interesecting the arrays

            for (var key in filteredSets) {
                if (filteredSets.hasOwnProperty(key) && key !== filterDimension) {
                    arrays.push(filteredSets[key]);
                }
            }
            var intersectedArray = (arrays.length > 1)
                ? intersection(arrays)
                : arrays[0];

            // Having performed that intersection, if necessary, how long is the resulting list of PIDs?
            // That number is the Count Hint for this checkbox
            $count.text(intersectedArray.length)

            // If there are NO potential matches for this checkbox,
            // then we disable it to reduce interface clutter
            $option.toggleClass('is-disabled visually-hidden', intersectedArray.length < 1);
            $checkbox.prop('disabled', intersectedArray.length < 1);
            
        });

    }


    /**
     * Test a product with a key/value pair (i.e. Color/Blue)
     * and see if it passes muster
     * 
     * @param  {String} dimension Gender, Category, Size, Color...
     * @param  {String} value     What is the value of said dimension (i.e. for Color: Blue? Red? Yellow?)
     * @param  {Object} storeItem HTML div element of product to evaluate
     * @return {Boolean} Did the product pass the test for the given dimension/value pair?
     */
    function testProduct (dimension, value, storeItem) {

        // Treat each filter dimension appropriately
        switch(dimension) {

            case 'size':
                // Does the desired size exist for this item, AND is it in stock?
                // (I don’t care if you have my size in THEORY, I want to know if I can actually buy it)
                return ($(storeItem).attr('data-' + dimension + '-' + value) === 'in-stock');

            case 'color':
                // Each apparel item has two colors stored in its metadata (`color1`, `color2`)
                // We’ll restrict our filter to the dominant color (`color1`) to avoid user confusion
                return ($(storeItem).attr('data-color1') === value);
            
            case 'price':
                // Price ranges come like this: `0-24.99` (Under $25)
                // So we want to take the String `0-24.99` and transform it into an Array of Numbers [0,24.99]
                var price_range = value.split('-').map(Number),
                    prod_price = parseFloat($(storeItem).attr('data-' + dimension));
                
                // See if the product’s falls within the price range
                return (prod_price >= price_range[0] && prod_price <= price_range[1]);

            default:
                // If this filter dimension doesn’t have any special considerations:
                return ($(storeItem).attr('data-' + dimension) === value);
        }
    }



    /**
     * Go through the UI and tally up all the filter options
     * the user has checked off
     *
     * @return {Object} params
     * This return value will look something like
     * `{gender: undefined, category: "t-shirt", size: undefined, color: "gray", price: undefined}`
     * We’ll clean up those `undefined` bits in `cleanParams()`
     */
    function gatherParams () {

        /**
         * An object to store all the parameters we find
         * @type {Object}
         */
        var params = {};


        // Look at each filter (Category, Size, Color...)
        $('.filter[data-filter-key]').each(function(){
            var $el = $(this),
                $checked = $el.find('input:checked'),
                $unchecked = $el.find('input:not(:checked)'),
                key = $el.attr('data-filter-key'),
                val;

            // Did we find any checked boxes? (More than 1?)
            if ($checked.length > 1) {
                var arr = [];

                // Push the value of each one to an array
                $.each($checked, function(){
                    arr.push($(this).val());
                });

                // Join the array into a string that could be used in a URL
                val = arr.join(',');

            // Supposing there was only one checked box,
            // Then we don't have to mess with any arrays
            } else if ($checked.length > 0) {
                val = $checked.val();
            }

            // Store the result for later reference
            // i.e. params['color'] = 'blue,gray' or params['color'] = 'gray'
            params[key] = val;
        });

        return params;
    }



    /**
     * Clean up the query paramters so we don’t have to worry about 
     * how to filter for such conditions as `size: undefined`
     * and we don’t end up putting some `size=undefined` gobbledygook in the URL
     * 
     * @param  {Object} params An object containing query parameters, such as:
     *     {gender: undefined, category: "t-shirt", size: undefined, color: "gray", price: undefined}
     *     
     * @return {Object} params An object containing the cleaned paramaters
     *     {category: "t-shirt", color: "gray"}
     */
    function cleanParams (params) {

        Object.keys(params).forEach(function(key) {
            if (params[key] == null || params[key] == ''){
                delete params[key];
            }
        });

        return params;
    }


    /**
     * Traverse an object containing filter paramaters
     * such as `{category: "t-shirt", color: "gray"}`
     * and find all the Gray T-Shirts so we can show them to the user
     * 
     * @param  {Object} params An object containing filter params
     * @param  {String} directionInTime Expected value is `forward` or `backward`
     */
    function traverseParams (params, directionInTime) {

        /**
         * An object to store matching Product IDs for each filter dimension
         * @type {Object}
         */
        var filteredSets = {};

        /**
         * A more generic view of filteredSets
         * @type {Array}
         */
        var unlabeledFilteredSets = [];

        /**
         * paramCount keeps track of how many params we are evaluating against
         * @type {Number}
         */
        var paramCount = 0;

    
        // Iterate over the filter params to build up the filteredSets
        // Check first to make sure the params aren’t empty
        // The resulting filteredSet will look something like this:
        // `{
        //     category: (6) [4946, 4940, 4972, 4966, 5539, 4175]
        //     color: (14) [6296, 4946, 4966, 4933, 4953, 5035, 6289, 6275, 6282, 5539...] 
        // }`
        // Here we have a filtered set of 6 PIDs that match on `category`
        // and a filtered set of 14 PIDs that match on `color`.
        // Later we’ll cross-reference the sets to find the PIDs
        // that meet all of our filter requirements

        if (!$.isEmptyObject(params)) {
            for (var i=0, j=filterDimensions.length; i<j; ++i) {
                
                var filterDimension = filterDimensions[i];
                
                // Do we have parameters to evaluate for this filter dimension?
                if (params[filterDimension]) {

                    // Convert the parameters into an array
                    // i.e. `black,blue` becomes ['black', 'blue']
                    var attributes = params[filterDimension].split(',')
                    paramCount++;

                    // Create an array to hold matching PIDs
                    filteredSets[filterDimension] = [];

                    // Iterate over each product ($storeItem) to see if it’s a match
                    $storeItems.each(function(index, product){

                        // Start with the assumption that this product is not a match
                        var matches = 0;
                        
                        // Take each attribute (i.e. black, blue...)
                        // and see if this product tests positive for that attribute
                        $.each(attributes, function(index, attribute){
                            if ( testProduct(filterDimension, attribute, product) ) {
                                matches++;
                            }
                        });

                        // Did this product pass any of the tests?
                        if (matches > 0) {

                            // If it did pass, grab its ID from the DOM and push it to an array
                            filteredSets[filterDimension].push(parseInt($(product).attr('data-product-id')));
                        }
                    });
                
                }
            }


            // Iterate over the filteredSets we just created
            // and make a copy of those key-value pairs, without the keys (just values)
            // So...
            // `{
            //     category: (6) [4946, 4940, 4972, 4966, 5539, 4175]
            //     color: (14) [6296, 4946, 4966, 4933, 4953, 5035, 6289, 6275, 6282, 5539...] 
            // }`
            // becomes...
            // `[
            //     [4946, 4940, 4972, 4966, 5539, 4175],
            //     [6296, 4946, 4966, 4933, 4953, 5035, 6289, 6275, 6282, 5539...]
            // ]`
            // This unlabeled set of PID arrays can later be fed into our `intersection()` function

            for (var key in filteredSets) {
                if (filteredSets.hasOwnProperty(key)) {
                    unlabeledFilteredSets.push(filteredSets[key]);
                }
            }


            // Perform an intersection of the PID arrays
            // to find only the PIDs that are present in EVERY array.
            // (If there is only one array of PIDs, we can shortcut it.)

            var intersectedArray = (unlabeledFilteredSets.length > 1)
                ? intersection(unlabeledFilteredSets)
                : unlabeledFilteredSets[0];
        }



        // If there were any parameters we filtered on (paramCount),
        // then show the filtered products ($storeItems)
        // If there were no filter parameters, then we just show ALL $storeItems

        if (paramCount > 0) {

            // Update the UI to show that, yes, there ARE filters to CLEAR if you need to
            $('.btn-clear-filters').addClass('is-enabled');
            $('.btn-clear-filters--mobile').removeClass('is-disabled');

            // Update the UI to show how many products we’ve narrowed it down to
            $('.filter-caption-text').text('Narrowed to ' + intersectedArray.length + ' items');
            $('.filter-caption-text--mobile').text('(' + intersectedArray.length + ' items)');

            // Hide all the products, then show only the matching ones
            $storeItems.hide().filter(function(index, el){
                return ($.inArray( parseInt($(el).attr('data-product-id')), intersectedArray ) > -1);
            }).show();

        } else {

            // Disable the CLEAR buttons if there are no filters to clear
            $('.btn-clear-filters').removeClass('is-enabled');
            $('.btn-clear-filters--mobile').addClass('is-disabled');

            // Update the UI to show the total number of products
            $('.filter-caption-text').text($storeItems.length + ' items');
            $('.filter-caption-text--mobile').text('(' + $storeItems.length + ' items)');

            // Show all the products
            $storeItems.show();
        }

        // Refresh the lazy-loaded product images
        if (bLazy && bLazy.revalidate) {
            bLazy.revalidate();
        }

        // Update the hint text next to each filter checkbox
        // that shows how many matching items that filter has
        updateCountHints(filteredSets);

        // Provided that the user is making NEW filter choices
        // and not going BACK in their browser history,
        // update the URL accordingly and push a record of it to their history
        if (directionInTime === 'forward') {
            var new_location = (!$.isEmptyObject(params))
                ? window.location.pathname + '?' + $.param(params)
                : window.location.pathname;
            
            history.pushState(params, "", new_location);
        }

    }



    /**
     * Function to call when a filter checkbox is clicked/changed
     * 
     * @param  {Object} [event] 
     *     The implicit event this function will receive if triggered by a user click
     *     vs. triggered in code, such as `$checkbox.prop('checked', true)`
     */
    function checkboxChange (event) {
        if (event) {
            var $checkbox = $(event.currentTarget),
                checked = $checkbox.is(':checked'),
                $li = $checkbox.closest('li');

            // Make sure that the `<li>` containing said checkbox
            // reflects the checkbox’s current state (for CSS purposes)
            $li.toggleClass('is-checked', checked);
        }

        // Gather up the current filter parameters and process them
        var params = gatherParams();
        params = cleanParams(params);
        traverseParams(params, 'forward');
    }



    /**
     * Upon loading the page, are there any filter parameters
     * encoded in the URL query string that we need to respect?
     */
    function applyInitialFilters () {
        var queryString = window.location.search.slice(1);

        if (queryString) {
            var params = $.parseParams(queryString);
            params = cleanParams(params);
            matchUiStateToParams(params);
            traverseParams(params, 'forward');
        } else {
            traverseParams({}, 'forward');
            updateCountHints({});
        }
    }



    /**
     * Allow the user to navigate backward through their previous filter choices
     * 
     * @param  {Object} event The implied event object that is passed by the
     *     window.popstate event handler
     */
    function goBackwardInFilterHistory (event) {
        var params = event.originalEvent.state;
        clearCheckboxes();
        matchUiStateToParams(params);
        traverseParams(params, 'backward');
    };
    


    /**
     * When the user navigates back in their history of filter choices
     * or when we apply the initial filters (on page load, from a URL query string)
     * we’ll need a way to make the UI reflect that
     * 
     * @param  {Object} params An object with filter parameters
     */
    function matchUiStateToParams(params) {

        // If there’s nothing to work with, just leave early
        if (!params) return;

        // Say we’ve got `color=blue,black&size=large`
        // Go through the UI and turn on the checkboxes for Blue, Black, and Large
        $.each(params, function(key, value){
            if (value === '') return;

            var arr = value.split(',');

            for (var i=0, j=arr.length; i<j; ++i) {
                var $checkbox = $('.filter[data-filter-key="' + key + '"] input[value="' + arr[i] + '"]');
                $checkbox.prop('checked', true).closest('li').addClass('is-checked');
            }
            
        });
    }

})(jQuery);